export const LEGACY_TASK_STATUS_MAP: Record<string, string> = {
  todo: 'unassigned',
  review: 'developer_completed',
  qa_pending: 'developer_completed',
  testing: 'qa_in_review',
  completed: 'done',
  dev_completed: 'developer_completed',
}

export const TASK_STATUS_ORDER = [
  'unassigned',
  'open',
  'in_progress',
  'waiting_client',
  'on_hold',
  'developer_completed',
  'qa_in_review',
  'qa_failed',
  'done',
  'cancelled',
] as const

export function normalizeTaskStatus(status?: string | null, assignedTo?: string | null): string {
  const raw = (status || '').trim().toLowerCase().replace(/[\s-]+/g, '_')
  const hasAssigneeContext = assignedTo !== undefined

  if (!raw) {
    if (!hasAssigneeContext) return 'unassigned'
    return assignedTo ? 'open' : 'unassigned'
  }

  const mapped = LEGACY_TASK_STATUS_MAP[raw] || raw

  if (hasAssigneeContext && mapped === 'unassigned' && assignedTo) return 'open'
  if (hasAssigneeContext && mapped === 'open' && !assignedTo) return 'unassigned'

  return mapped
}

export function isTaskCompletedStatus(status?: string | null, assignedTo?: string | null): boolean {
  return normalizeTaskStatus(status, assignedTo) === 'done'
}

export function isTaskTerminalStatus(status?: string | null, assignedTo?: string | null): boolean {
  const normalized = normalizeTaskStatus(status, assignedTo)
  return normalized === 'done' || normalized === 'cancelled'
}

export function getNormalizedTaskStatusCounts(
  tasks: Array<{ status?: string | null; assignedTo?: string | null; assigned_to?: string | null }>
): Record<string, number> {
  const counts: Record<string, number> = {}
  for (const task of tasks) {
    const assignee = task.assignedTo ?? task.assigned_to ?? null
    const normalized = normalizeTaskStatus(task.status, assignee)
    counts[normalized] = (counts[normalized] || 0) + 1
  }
  return counts
}

export function formatTaskStatusLabel(status: string): string {
  if (status === 'developer_completed' || status === 'qa_pending' || status === 'dev_completed') return 'Developer Completed'
  return status.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
}
